export const defaultPlatform = {id: "qr", title: "QR Application", image: "qrcode.png"}

